// 签名列表api
import request from '@/utils/request'
export const pageListApi = (data) => {
    return request({
        url: 'Signatures/List',
        method: 'post',
        data
    })
}